import React from "react"
import { firestore } from "../../core"
import { useSelectionNominates, useSelectionPseudoNominates } from "popopo-lib-front/firestore-access"
import { User } from "firebase/auth"
import { LiveId, SelectionId, SelectionSequenceId, SpaceKey } from "popopo-msg"
import { SelectionNominateSelectButton } from "./SelectionNominateSelectButton"
import { SelectionNominateAppealButton } from "./SelectionNominateAppealButton"

export const SelectionNominateList = (props: {
  firebase: User;
  spaceKey: SpaceKey;
  liveId: LiveId;
  selectionId: SelectionId;
  kind: "nominate" | "pseudo-nominate"
  latestSequence: SelectionSequenceId | null;
}) => {

  return props.kind === "nominate"
    ? <SelectionNominateListNominate {...props} />
    : <SelectionNominateListPseudoNominate {...props} />
}

const SelectionNominateListPseudoNominate = (props: {
  firebase: User;
  spaceKey: SpaceKey;
  liveId: LiveId;
  selectionId: SelectionId;
}) => {
  const nominates = useSelectionPseudoNominates(firestore, props.spaceKey, props.liveId, props.selectionId)

  return (
    <>
      <ul className="list-group w-100">
        {nominates === "loading" ? (
          <li>
            <i className="fas fa-spin fa-spinner"/>
          </li>
        ) : nominates.length === 0 ? (
          <li>ノミネートは1つも存在しません。</li>
        ) : (
          nominates.map((nominate) => (
            <li key={nominate.id} className="list-group-item">
              {nominate.id}
            </li>
          ))
        )}
      </ul>
    </>
  )
}

const SelectionNominateListNominate = (props: {
  firebase: User;
  spaceKey: SpaceKey;
  liveId: LiveId;
  selectionId: SelectionId;
  latestSequence: SelectionSequenceId | null;
}) => {
  const nominates = useSelectionNominates(firestore, props.spaceKey, props.liveId, props.selectionId)

  return (
    <>
      <ul className="list-group w-100">
        {nominates === "loading" ? (
          <li>
            <i className="fas fa-spin fa-spinner"/>
          </li>
        ) : nominates.length === 0 ? (
          <li>ノミネートは1つも存在しません。</li>
        ) : (
          nominates.map((nominate) => (
            <li key={nominate.id} className="list-group-item">
              {nominate.id} (status: {nominate.nominate}, selected: {nominate.selected}, appeal: {nominate.appeal?.kind ?? "None"})
              <SelectionNominateSelectButton {...props} participantId={nominate.id}/>
              <SelectionNominateAppealButton {...props} participantId={nominate.id}/>
            </li>
          ))
        )}
      </ul>
    </>
  )
}
